import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ProductsList from "../LicenseManagement/ProductsList";

const StudentLicenseManagemenModal = ({
  preselectedStudent,
  className,
  toggle,
  isOpen,
}) => {
  const toggleModal = () => {
    toggle();
  };

  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}></ModalHeader>
      <ModalBody>
        <ProductsList
          preselectedStudent={preselectedStudent}
          className={className}
          inModal={true}
        />
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (store) => {
  return {
    products: store.productsReducer,
    cart: store.newCartReducer,
    students: store.teacherStudentReducer,
    teacherInfo: store.teacherInformationReducer,
    studentWithLicenses: store.studentWithLicenseReducer,
  };
};

export default withRouter(
  connect(mapStateToProps)(StudentLicenseManagemenModal)
);
